import { useTranslation } from "react-i18next";
import { CiCircleCheck } from "react-icons/ci";
import React from "react";
const BookingSuccess = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col w-full m-auto items-center justify-center h-[80%]">
      <CiCircleCheck className="size-[135px] text-primary" />
      <p className="text-[#515557] text-center mx-6 text-lg mt-6">
        {t("book_location.venue_reservation_overview.success_message")}
      </p>
    </div>
  );
};

export default BookingSuccess;
